import classNames from 'classnames'

import { CheckboxBase, ICheckboxCommonProps } from 'core-components/library/checkbox/CheckboxBase'

import styles from './Checkbox.module.scss'

export interface ICheckboxProps extends ICheckboxCommonProps {
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Indicates that a checkbox is neither "on" nor "off".
   */
  indeterminate?: boolean
}

export const Checkbox = ({
  className,
  label,
  checked,
  onChange,
  margin,
  padding,
  size = 'md',
  inline,
  disabled,
  wrapper,
  indeterminate,
  __testId,
}: ICheckboxProps) => {
  return (
    <CheckboxBase
      testid={__testId || 'checkboxRoot'}
      testidInput={'checkboxInput'}
      classes={{
        root: className || '',
        inner: styles.inner,
        control: styles.control,
        icon: classNames(styles.icon, wrapper && styles[`icon--${wrapper}`]),
        iconChecked: styles['icon--checked'],
        iconIndeterminate: styles['icon--indeterminate'],
        iconDisabled: styles['icon--disabled'],
        label: styles.label,
      }}
      label={label}
      checked={checked}
      onChange={onChange}
      margin={margin}
      padding={padding}
      size={size}
      inline={inline}
      disabled={disabled}
      wrapper={wrapper}
      indeterminate={indeterminate}
    />
  )
}
